(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sj-ask-nutritionist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseNutritionistForm = (root = document) => {
      root.querySelectorAll('[data-nutritionist-form]').forEach((form) => {
        if (form.dataset.initialised === 'true') return;
        form.dataset.initialised = 'true';

        const consultationOther = form.querySelector('[data-consultation-other]');
        const consultationOtherInput = consultationOther?.querySelector('input');
        const consultationRadios = form.querySelectorAll('input[name="contact[Consultation for]"]');

        const updateConsultationOther = () => {
          const selected = form.querySelector('input[name="contact[Consultation for]"]:checked');
          const showOther = selected?.value === 'Other';

          if (consultationOther) consultationOther.hidden = !showOther;
          if (consultationOtherInput) consultationOtherInput.required = showOther;
        };

        consultationRadios.forEach((radio) => radio.addEventListener('change', updateConsultationOther));
        updateConsultationOther();

        const healthCheckboxes = [...form.querySelectorAll('[data-health-concern]')];
        const healthError = form.querySelector('[data-health-concern-error]');
        const healthOther = form.querySelector('[data-health-other]');
        const healthOtherInput = healthOther?.querySelector('input');

        const updateHealthFields = () => {
          const selectedCount = healthCheckboxes.filter((checkbox) => checkbox.checked).length;
          const otherSelected = healthCheckboxes.some(
            (checkbox) => checkbox.checked && checkbox.name.includes('Health concern - Other')
          );

          healthCheckboxes[0]?.setCustomValidity(selectedCount > 0 ? '' : 'Please select at least one health concern.');
          if (healthError) healthError.hidden = selectedCount > 0;
          if (healthOther) healthOther.hidden = !otherSelected;
          if (healthOtherInput) healthOtherInput.required = otherSelected;
        };

        healthCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', updateHealthFields));
        updateHealthFields();

        form.addEventListener('submit', (event) => {
          updateHealthFields();

          if (!form.checkValidity()) {
            event.preventDefault();
            form.reportValidity();
          }
        });
      });

      root.querySelector('[data-form-success]')?.focus();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseNutritionistForm());
    } else {
      initialiseNutritionistForm();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseNutritionistForm(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
